// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#app {\r\n  font-family: Helvetica, Arial, sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  text-align: center;\r\n  color: #2c3e50;\r\n  line-height: normal;\r\n  background-color: white;\n}\n:root {\r\n  --menu-pad-mobile: 110px;\r\n  --menu-pad-wide-a: 210px;\r\n  --menu-pad-wide-b: 175px;\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
